export const DEFAULT_MATERIAL_COLOR = [227, 46, 46] as [number, number, number];
export const METAL_GENERAL_COLOR = [213, 77, 77] as [number, number, number];
export const STONE_GENERAL_COLOR = [116, 112, 87] as [number, number, number];
export const CERAMIC_GENERAL_COLOR = [189, 153, 104] as [
  number,
  number,
  number
];
const BONE_GENERAL_COLOR = [206, 201, 175] as [number, number, number];
const BRASS_COLOR = [147, 169, 100] as [number, number, number];
const BRONZE_COLOR = [66, 182, 34] as [number, number, number];
const CLAY_COLOR = [100, 81, 55] as [number, number, number];
const COPPER_COLOR = [168, 205, 31] as [number, number, number];
const GLASS_COLOR = [28, 110, 255] as [number, number, number];
const GOLD_COLOR = [255, 197, 14] as [number, number, number];
const IRON_COLOR = [71, 71, 71] as [number, number, number];
const KNAPPED_STONE_COLOR = [206, 198, 156] as [number, number, number];
const LEAD_COLOR = [128, 128, 128] as [number, number, number];
const MOLLUSC_SHELL_COLOR = [202, 235, 212] as [number, number, number];
const SAPROPELITE_COLOR = [58, 47, 32] as [number, number, number];
const SILVER_COLOR = [174, 216, 255] as [number, number, number];
const TIN_COLOR = [108, 108, 108] as [number, number, number];

export const materials = {
  brass: `rgb(${BRASS_COLOR.join(', ')})`,
  bronze: `rgb(${BRONZE_COLOR.join(', ')})`,
  iron: `rgb(${IRON_COLOR.join(', ')})`,
  silver: `rgb(${SILVER_COLOR.join(', ')})`,
  lead: `rgb(${LEAD_COLOR.join(', ')})`,
  stone: `rgb(${STONE_GENERAL_COLOR.join(', ')})`,
  glass: `rgb(${GLASS_COLOR.join(', ')})`,
  gold: `rgb(${GOLD_COLOR.join(', ')})`,
  copper: `rgb(${COPPER_COLOR.join(', ')})`,
};

export const getMaterialColor = (
  material: string,
  draft?: boolean
): [number, number, number] => {
  if (draft) {
    return DEFAULT_MATERIAL_COLOR;
  }

  switch (material) {
    case 'bone general':
      return BONE_GENERAL_COLOR;
    case 'brass':
      return BRASS_COLOR;
    case 'bronze':
      return BRONZE_COLOR;
    case 'ceramic daub':
      return CERAMIC_GENERAL_COLOR;
    case 'clay':
      return CLAY_COLOR;
    case 'copper':
      return COPPER_COLOR;
    case 'glass':
      return GLASS_COLOR;
    case 'gold':
      return GOLD_COLOR;
    case 'iron':
      return IRON_COLOR;
    case 'knapped stone':
      return KNAPPED_STONE_COLOR;
    case 'lead':
      return LEAD_COLOR;
    case 'metal general':
      return METAL_GENERAL_COLOR;
    case 'mollusc shell':
      return MOLLUSC_SHELL_COLOR;
    case 'non-ferrous metal':
      return METAL_GENERAL_COLOR;
    case 'polished stone':
      return STONE_GENERAL_COLOR;
    case 'pottery general':
      return CERAMIC_GENERAL_COLOR;
    case 'sapropelite':
      return SAPROPELITE_COLOR;
    case 'silver':
      return SILVER_COLOR;
    case 'stone general':
      return STONE_GENERAL_COLOR;
    case 'tin':
      return TIN_COLOR;
    case 'other material':
      return DEFAULT_MATERIAL_COLOR;
    case 'unknown':
      return DEFAULT_MATERIAL_COLOR;
    default:
      return DEFAULT_MATERIAL_COLOR;
  }
};
